export default __webpack_public_path__ + "static/media/bookLabTestBackground.f18392b4.png";